<template>
  <v-container fluid class="admin-booking">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               class="mr-4"
               @click="exportBookings">
          {{ $t('admin_acc_booking.export') }}
        </v-btn>
        <v-btn color="primary"
               @click="addBooking">
          {{ $t('admin_acc_booking.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <AdminBookingList full-height
                      :refresh-trigger.sync="bookingRefreshTrigger"
                      @edit="onBookingEdit"></AdminBookingList>

    <EditBookingModal :shown="editBookingModalShown"
                      :booking-id="editingBookingId"
                      @cancel="editBookingModalShown = false"
                      @finish="onEditBookingModalFinish"></EditBookingModal>
  </v-container>
</template>
<script>
import {ref} from "@vue/composition-api";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList";
import AddBookingModal from "@/components/acc_booking/booking/AddBookingModal";
import EditBookingModal from "@/components/acc_booking/booking/EditBookingModal";
import ExportBookingModal from "@/components/acc_booking/booking/ExportBookingModal";

export default {
  name: 'Booking',
  components: {EditBookingModal, AddBookingModal, AdminBookingList},
  setup(props, {root}) {
    const bookingRefreshTrigger = ref(false);
    const refreshBooking = function () {
      bookingRefreshTrigger.value = !bookingRefreshTrigger.value;
    };

    const addBooking = async function () {
      const needRefresh = await root.$dialog.showAndWait(AddBookingModal, {
        showClose: false,
        persistent: true,
        width: '80vw',
      });

      if (needRefresh) {
        refreshBooking();
      }
    }
    const exportBookings = async function () {
      await root.$dialog.showAndWait(ExportBookingModal, {
        showClose: false,
        persistent: true,
      })
    }

    const editingBookingId = ref(null);
    const editBookingModalShown = ref(false);
    const onBookingEdit = function (item) {
      editingBookingId.value = item.id;
      editBookingModalShown.value = true;
    };
    const onEditBookingModalFinish = function () {
      editBookingModalShown.value = false;
      refreshBooking();
    }

    return {
      bookingRefreshTrigger,
      refreshBooking,

      addBooking,
      exportBookings,

      editingBookingId,
      editBookingModalShown,
      onBookingEdit,
      onEditBookingModalFinish,
    }
  }
}
</script>

<style lang="less">
.admin-booking {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

